import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="space-attd-val"
export default class extends Controller {

  static values = { capacity: Number }

  connect() {
    const input = this.element.querySelector('#booking_attendee_count')
    const incr = this.element.querySelector('.attendees__incr')
    const decr = this.element.querySelector('.attendees__decr')
    let i =  this.capacityValue;
    let maxCapacity = Number(this.element.dataset.maxCapacity)

    input.addEventListener('change', () => {
      i = input.value;
    })

    incr.addEventListener('click', () => {
      if(i < maxCapacity || !i || !maxCapacity){
        i++;
        input.value = i;
      }
    })
    decr.addEventListener('click', () => {
      if(i >= 2){
        i--;
        input.value = i;
      }
    })
  }
}
